const app = require('./app').default;

export default app;